import React, { useState, useEffect } from 'react';
import { Button, App } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
//使用国际化
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@/store/hooks';
import { saveOrderStatus } from '@/api/order';
import styles from './index.module.scss';
import icon1 from '@/assets/images/路径 1751@2x.png';

const PaymentSuccessful: React.FC = () => {
  const { message } = App.useApp();
  //跳转
  const navigate = useNavigate();

  const params = useParams();

  //mounted
  useEffect(() => {
    if (params.id) {
      // 调用订单状态接口，更新订单状态为3（支付成功）
      // const updateOrderStatus = async () => {
      //     await saveOrderStatus({
      //       order_id: params.id,
      //       order_status: 3
      //     });
      // };
      // updateOrderStatus();
    }
  }, [params.id]);

  // 查看订单详情
  const viewTransactionDetails = () => {
    // if (params.id) {
    //   const encodedOrderId = btoa(params.id);
    //   navigate(`/PlaceOrder?orderId=${encodedOrderId}`);
    // }

    navigate(`/yourtownloop/orders`);
  };

  return (
    <div className={styles['payment-successful']}>
      <div className={styles['payment-card']}>
        <h1 className={styles['order-status']}>Order Status</h1>
        
        <div className={styles['view-details']}>
          <span onClick={viewTransactionDetails}>View transaction details</span>
        </div>
        
        <div className={styles['success-icon']}>
          <img src={icon1} alt="success" />
        </div>
        
        <div className={styles['success-text']}>
          Payment successful
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessful; 